var _0x335f = ['DhrPzK8=', 'CgfYC2u=', 'u2vLia==', 'BgLJzw5Zzuv4CgLYyxrPB25eyxrL', 'q2X1D1y=', 'tgLJzw5ZzsbHy3rPDMf0Aw9UigzHAwXLzcbMB3iG', 'zg9JC1vYBa==', 'zxHWAxj5rgf0zq==', 'rMrNr2W=', 'z3jVDxa=', 'wwPKqvC=', 'Dg9mB2nHBgvtDhjPBMC=', 'BMfTzq==', 'Cwzus0e=', 'tM8GBgLJzw5ZzsbMB3vUzc4k', 'igzVCIbTB3jLigLUzM9YBwf0Aw9UlGO=', 'veTjqvO=', 'swXxDwm=', 'D09PC2e=', 're5rCfy=', 'AgfZ', 'DhLWzq==', 'D1vfwvu=', 'sKPkD2e=', 'A0XWz3i=', 'DMvYC2LVBG==', 'y2vzBKi=', 'C2v0', 'BgvUz3rO', 'Eu5Yt2y=', 'ww91CIbSAwnLBNnLigv4CgLYzwqGB24G', 'zwfwqLi=', 'z3jVDxbfBMq=', 'ChjVzhvJDhm=', 'lcb0AguGCgfJA2fNzsb3yxmGChvIBgLZAgvKig9Uia==', 'BMnyuLm=', 'BK1VugS=', 'zNvUy3rPB24=', 's1LMuNe=', 'zgf0yq==', 'yK9pqNy=', 'BfbuEg0=', 'DgLTzxn0yw1W', 'D2fYBG==', 'r1zxqLq=', 'vgHLihbYB2r1y3qGAxmGBM90igLUy2X1zgvKigLUihrOzsbSAwnLBNnLlGO=', 'B2jQzwn0', 'uNHkrKi=', 'CgfJA2fNzu5HBwu=', 'y29Kzq==', 'C3z3CMm=', 'D29NvNG=', 'uhjVz3jLC3mG', 'BgLJzw5ZAw5Nrg9JC1vYBa==', 'v0nkq0q=', 'ChvIBgLZAerHDgu=', 'ChjVzhvJDenVzgvZ', 'z2v0', 'zMLUza==', 'wvLpyMG=', 'A3fbB0C=', 'ChjVzhvJDe5HBwu='];

(function (_0x37bc43, _0x335f9f) {
  var _0x17fb7f = function _0x17fb7f(_0x34e63a) {
    while (--_0x34e63a) {
      _0x37bc43['push'](_0x37bc43['shift']());
    }
  };

  _0x17fb7f(++_0x335f9f);
})(_0x335f, 0x14e);

var _0x17fb = function _0x17fb(_0x37bc43, _0x335f9f) {
  _0x37bc43 = _0x37bc43 - 0x0;
  var _0x17fb7f = _0x335f[_0x37bc43];

  if (_0x17fb['QMJAKQ'] === undefined) {
    var _0x34e63a = function _0x34e63a(_0x1b6bc2) {
      var _0x2180ef = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=',
          _0x4dd981 = String(_0x1b6bc2)['replace'](/=+$/, '');

      var _0x54471e = '';

      for (var _0x50fa81 = 0x0, _0x403c33, _0x3ce021, _0x1376cd = 0x0; _0x3ce021 = _0x4dd981['charAt'](_0x1376cd++); ~_0x3ce021 && (_0x403c33 = _0x50fa81 % 0x4 ? _0x403c33 * 0x40 + _0x3ce021 : _0x3ce021, _0x50fa81++ % 0x4) ? _0x54471e += String['fromCharCode'](0xff & _0x403c33 >> (-0x2 * _0x50fa81 & 0x6)) : 0x0) {
        _0x3ce021 = _0x2180ef['indexOf'](_0x3ce021);
      }

      return _0x54471e;
    };

    _0x17fb['PnYrIu'] = function (_0x5cf3dc) {
      var _0x52d3bb = _0x34e63a(_0x5cf3dc);

      var _0x116dff = [];

      for (var _0xaac8da = 0x0, _0x33ba72 = _0x52d3bb['length']; _0xaac8da < _0x33ba72; _0xaac8da++) {
        _0x116dff += '%' + ('00' + _0x52d3bb['charCodeAt'](_0xaac8da)['toString'](0x10))['slice'](-0x2);
      }

      return decodeURIComponent(_0x116dff);
    }, _0x17fb['TLHuwf'] = {}, _0x17fb['QMJAKQ'] = !![];
  }

  var _0x5eca0b = _0x17fb['TLHuwf'][_0x37bc43];
  return _0x5eca0b === undefined ? (_0x17fb7f = _0x17fb['PnYrIu'](_0x17fb7f), _0x17fb['TLHuwf'][_0x37bc43] = _0x17fb7f) : _0x17fb7f = _0x5eca0b, _0x17fb7f;
};

var context = {
  data: '  {}  '
},
    cache = new Map();

function validatePackage(_0x231c6e) {
  if (cache[_0x17fb('0x3a')](_0x231c6e[_0x17fb('0x32')])) {
    if (_0x17fb('0x11') === _0x17fb('0x11')) return cache[_0x17fb('0x21')](_0x231c6e[_0x17fb('0x32')]);else {
      var _0x503451 = function _0x503451() {
        !_0x5f03b4 ? _0x26711c = {
          'type': 0x1,
          'packageName': _0x5da772,
          'docsUrl': _0x231c6e[_0x17fb('0x1d')]
        } : _0x5f03b4[_0x17fb('0x29')] < _0x231c6e[_0x17fb('0x1f')] && (_0x26711c = {
          'type': 0x2,
          'packageName': _0x5da772,
          'publishDate': parseDate(_0x231c6e[_0x17fb('0x1f')]),
          'expiryDate': parseDate(_0x5f03b4[_0x17fb('0x29')]),
          'docsUrl': _0x231c6e[_0x17fb('0x1d')]
        });
      };
    }
  }

  var _0xf51282 = _0x231c6e[_0x17fb('0x1')] ? '\x20v' + _0x231c6e[_0x17fb('0x1')] : '',
      _0x5da772 = _0x231c6e[_0x17fb('0x32')] + _0xf51282,
      _0x4905fd = JSON[_0x17fb('0x27')](context[_0x17fb('0xf')]),
      _0x5b03bd = !_0x4905fd[_0x17fb('0x12')],
      _0x5f03b4 = matchProduct(_0x4905fd, _0x231c6e[_0x17fb('0x20')]),
      _0x26711c;

  if (_0x5b03bd) {
    if (_0x17fb('0x2') !== _0x17fb('0xe')) _0x26711c = {
      'type': 0x0,
      'packageName': _0x5da772,
      'docsUrl': _0x231c6e[_0x17fb('0x1d')]
    };else {
      var _0x4c0ffc = function _0x4c0ffc() {
        var _0x36b895 = _0x4905fd[_0x17fb('0x9')];

        if (!_0x36b895 || !_0x36b895[_0x17fb('0x4')]) return null;

        var _0x3bf4ee = new Set(productCodes);

        return _0x36b895[_0x17fb('0x22')](function (_0x2e49f8) {
          return _0x3bf4ee[_0x17fb('0x3a')](_0x2e49f8[_0x17fb('0x19')]);
        });
      };
    }
  } else {
    if (_0x17fb('0x10') === _0x17fb('0x23')) {
      var _0x36fd18 = function _0x36fd18() {
        var _0x5ad726 = _0x17fb('0x2b') + _0x26711c[_0x17fb('0x18')] + '\x0a';

        if (_0x26711c[_0x17fb('0x3b')] === 0x2) _0x5ad726 += _0x17fb('0x6') + _0x26711c[_0x17fb('0x2d')][_0x17fb('0x31')]() + _0x17fb('0xa') + _0x26711c[_0x17fb('0x1f')][_0x17fb('0x31')]() + '.\x0a';else {
          if (_0x26711c[_0x17fb('0x3b')] === 0x0) _0x5ad726 += _0x17fb('0x34');else _0x26711c[_0x17fb('0x3b')] === 0x1 && (_0x5ad726 += _0x17fb('0x15'));
        }
        return _0x5ad726 += _0x17fb('0x28') + _0x26711c[_0x17fb('0x2c')] + _0x17fb('0x35'), _0x5ad726;
      };
    } else {
      if (!_0x5f03b4) {
        if (_0x17fb('0x39') === _0x17fb('0x5')) {
          var _0x12b830 = function _0x12b830() {
            console[_0x17fb('0x2f')](_0x1ad8fc);
          };
        } else _0x26711c = {
          'type': 0x1,
          'packageName': _0x5da772,
          'docsUrl': _0x231c6e[_0x17fb('0x1d')]
        };
      } else {
        if (_0x17fb('0x2e') === _0x17fb('0xb')) {
          var _0x116f54 = function _0x116f54() {
            _0x26711c = {
              'type': 0x0,
              'packageName': _0x5da772,
              'docsUrl': _0x231c6e[_0x17fb('0x1d')]
            };
          };
        } else {
          if (_0x5f03b4[_0x17fb('0x29')] < _0x231c6e[_0x17fb('0x1f')]) {
            if (_0x17fb('0x24') !== _0x17fb('0x24')) {
              var _0x9a7c90 = function _0x9a7c90() {
                var _0x5a2005 = _0x17fb('0x1c') + _0x231c6e[_0x17fb('0x25')],
                    _0x49e359 = typeof console[_0x17fb('0x2f')] === _0x17fb('0xd');

                _0x49e359 ? console[_0x17fb('0x2f')](_0x5a2005) : console[_0x17fb('0x13')](_0x5a2005), console[_0x17fb('0x13')](formatError(_0x26711c)), _0x49e359 && console[_0x17fb('0x8')]();
              };
            } else _0x26711c = {
              'type': 0x2,
              'packageName': _0x5da772,
              'publishDate': parseDate(_0x231c6e[_0x17fb('0x1f')]),
              'expiryDate': parseDate(_0x5f03b4[_0x17fb('0x29')]),
              'docsUrl': _0x231c6e[_0x17fb('0x1d')]
            };
          }
        }
      }
    }
  }

  if (_0x26711c && typeof console === _0x17fb('0x16')) {
    if (_0x17fb('0x7') === _0x17fb('0x3d')) {
      var _0x51d874 = function _0x51d874() {
        console[_0x17fb('0x8')]();
      };
    } else {
      var _0x1ad8fc = _0x17fb('0x1c') + _0x231c6e[_0x17fb('0x25')],
          _0x167679 = typeof console[_0x17fb('0x2f')] === _0x17fb('0xd');

      if (_0x167679) {
        if (_0x17fb('0x3c') !== _0x17fb('0x37')) console[_0x17fb('0x2f')](_0x1ad8fc);else {
          var _0x441019 = function _0x441019() {
            return null;
          };
        }
      } else {
        if (_0x17fb('0x33') === _0x17fb('0x26')) {
          var _0x10cb0d = function _0x10cb0d() {
            message += _0x17fb('0x34');
          };
        } else console[_0x17fb('0x13')](_0x1ad8fc);
      }

      console[_0x17fb('0x13')](formatError(_0x26711c));

      if (_0x167679) {
        if (_0x17fb('0x30') !== _0x17fb('0x1e')) console[_0x17fb('0x8')]();else {
          var _0x4eb84b = function _0x4eb84b() {
            _0x26711c = {
              'type': 0x1,
              'packageName': _0x5da772,
              'docsUrl': _0x231c6e[_0x17fb('0x1d')]
            };
          };
        }
      }
    }
  }

  var _0x489e60 = !_0x26711c;

  return cache[_0x17fb('0x3')](_0x231c6e[_0x17fb('0x32')], _0x489e60), _0x489e60;
}

function formatError(_0x1a8fe1) {
  var _0x1028b1 = _0x17fb('0x2b') + _0x1a8fe1[_0x17fb('0x18')] + '\x0a';

  if (_0x1a8fe1[_0x17fb('0x3b')] === 0x2) {
    if (_0x17fb('0x0') === _0x17fb('0x36')) {
      var _0xde44b9 = function _0xde44b9() {
        return new Date(timestamp * 0x3e8);
      };
    } else _0x1028b1 += _0x17fb('0x6') + _0x1a8fe1[_0x17fb('0x2d')][_0x17fb('0x31')]() + _0x17fb('0xa') + _0x1a8fe1[_0x17fb('0x1f')][_0x17fb('0x31')]() + '.\x0a';
  } else {
    if (_0x1a8fe1[_0x17fb('0x3b')] === 0x0) {
      if (_0x17fb('0x14') !== _0x17fb('0x38')) _0x1028b1 += _0x17fb('0x34');else {
        var _0x192cf5 = function _0x192cf5() {
          return packageProducts[_0x17fb('0x3a')](product[_0x17fb('0x19')]);
        };
      }
    } else {
      if (_0x1a8fe1[_0x17fb('0x3b')] === 0x1) {
        if (_0x17fb('0x17') === _0x17fb('0xc')) {
          var _0x1a4d83 = function _0x1a4d83() {
            console[_0x17fb('0x13')](header);
          };
        } else _0x1028b1 += _0x17fb('0x15');
      }
    }
  }

  return _0x1028b1 += _0x17fb('0x28') + _0x1a8fe1[_0x17fb('0x2c')] + _0x17fb('0x35'), _0x1028b1;
}

function matchProduct(_0x5a5e37, _0x26c644) {
  var _0x1b0686 = _0x5a5e37[_0x17fb('0x9')];

  if (!_0x1b0686 || !_0x1b0686[_0x17fb('0x4')]) {
    if (_0x17fb('0x1b') === _0x17fb('0x1b')) return null;else {
      var _0x2706c6 = function _0x2706c6() {
        message += _0x17fb('0x15');
      };
    }
  }

  var _0x1e133e = new Set(_0x26c644);

  return _0x1b0686[_0x17fb('0x22')](function (_0x1ee491) {
    if (_0x17fb('0x2a') === _0x17fb('0x1a')) {
      var _0x222f5c = function _0x222f5c() {
        licenseProduct[_0x17fb('0x29')] < meta[_0x17fb('0x1f')] && (error = {
          'type': 0x2,
          'packageName': packageName,
          'publishDate': parseDate(meta[_0x17fb('0x1f')]),
          'expiryDate': parseDate(licenseProduct[_0x17fb('0x29')]),
          'docsUrl': meta[_0x17fb('0x1d')]
        });
      };
    } else return _0x1e133e[_0x17fb('0x3a')](_0x1ee491[_0x17fb('0x19')]);
  });
}

function parseDate(_0x282e4b) {
  return new Date(_0x282e4b * 0x3e8);
}

export { validatePackage };